module.exports = __webpack_public_path__ + "img/975337_EEBE98_4B211C_D88659-256px.487bdd69.png";